import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { AuftragEx, UnterschriftEx } from 'src/app/api/model/model';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { UnterschriftComponent } from 'src/app/shared/components/unterschrift/unterschrift.component';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { Subscription } from 'rxjs';
import { ImageHelper } from 'src/app/api/helper/image-helper';
import { MyApp } from 'src/app/api/helper/app';
import { ClickHelper } from 'src/app/api/helper/click-helper';
import { SystemService } from 'src/app/api/system.service';
import { AppConfig } from 'src/app/api/helper/app.config';
import { Utils } from 'src/app/api/helper/utils';

import moment from 'moment';

@Component({
    selector: 'app-auftrag-unterschrift',
    templateUrl: './auftrag-unterschrift.page.html',
    styleUrls: ['./auftrag-unterschrift.page.scss'],
    standalone: false
})
export class AuftragUnterschriftPage implements OnInit, AfterViewInit, OnDestroy {
    log = new Logger("AuftragUnterschriftPage");

    @ViewChild('unterschriftComponent', { static: false }) unterschriftComponent: UnterschriftComponent;
    @ViewChild('hiddenCanvans', { static: false }) hiddenCanvans: any;

    @Input() auftrag: AuftragEx;
    @Input() rolle: string;

    hiddenCanvasElement: HTMLCanvasElement;
    unterschrift: UnterschriftEx;
    datumHeute = '';
    speichernButtonColor = 'light';
    speichernDisabled = true;
    logo: string;
    statusmeldungAnzeigen = false;
    statusmeldungen: string;

    // Wenn die Positionen angezeigt werden sollen, dann wird dieser Text gefüllt (THEURL)
    positionenText = '';

    unterschriftTextBestaetigt = false;

    private subscriptions: Subscription[] = [];

    constructor(
        private cdr: ChangeDetectorRef,
        private auftragService: AuftragService,
        private systemService: SystemService,
        private modalController: ModalController) { }

    async ngOnInit() {
        // const auftragsKey = this.route.snapshot.paramMap.get('auftragsKey');
        // this.rolle = this.route.snapshot.paramMap.get('rolle');

        // this.auftrag = await this.auftragService.getAuftrag(auftragsKey);

        if (this.auftrag == null) {
            UiHelper.showError('Auftrag nicht gesetzt');
            return;
        }

        this.unterschrift = this.auftrag.Unterschriften.find(p => p.Typ == this.rolle);

        if (!this.unterschrift) {
            this.unterschrift = {
                Bild: null,
                Datum: null,
                Guid: null,
                Name: '',
                Typ: this.rolle,
                Data: null
            };

            this.auftrag.Unterschriften.push(this.unterschrift);
        }

        if (AppConfig.current.einstellungen.LogoAufUnterschritseiteAnzeigen == 'ja') {
            this.logo = AppConfig.current.einstellungen.Logo;
        }

        if (AppConfig.current.einstellungen.StatusmeldungenAufUnterschritseiteAnzeigen == 'ja') {
            this.statusmeldungAnzeigen = true;

            if (this.auftrag.statusmeldungen && this.auftrag.statusmeldungen.length > 0) {
                this.statusmeldungen = this.auftrag.statusmeldungen.map(meldung => meldung.name).join(', ');
            }
        }

        this.positionenText = '';

        if (AppConfig.current.einstellungen.PositionenAufUnterschritseiteAnzeigen == 'ja') {
            if (this.auftrag.Positionen?.length) {
                for (const pos of this.auftrag.Positionen) {
                    if (pos.Menge > 0) {
                        this.positionenText += `${pos.Bezeichnung}: ${pos.Menge} ${pos.Einheit}\n`;
                    }
                }
            }

            this.positionenText = this.positionenText.trim();
        }

        // if (this.auftrag.UnterschriftText) {
        //     if (this.positionenText) {
        //         this.positionenText += '\n';
        //     }

        //     this.positionenText += this.auftrag.UnterschriftText.trim();
        // }

        // Loading-Indicator ausblenden
        MyApp.loading(false);
    }

    ngOnDestroy() {
        this.log?.debug('ngOnDestroy');

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];
    }

    ngAfterViewInit() {
        this.hiddenCanvasElement = this.hiddenCanvans.nativeElement;
    }

    ionViewWillEnter() {
        this.datumHeute = moment().format('DD.MM.YYYY');
    }

    ionViewDidEnter() {
        MyApp.current.backAction = () => this.onAbbrechen(null);
    }

    ionViewWillLeave() {
        MyApp.current.backAction = null;
        MyApp.loading(false);
    }

    onAbbrechen(e: Event) {
        this.modalController.dismiss(false);
    }

    onSignaturVorhanden(component: UnterschriftComponent) {
        this.unterschriftComponent = component;

        if (this.unterschriftComponent.istSignaturVorhanden()) {
            this.speichernDisabled = false;
            this.speichernButtonColor = 'success';
        } else {
            this.speichernDisabled = true;
            this.speichernButtonColor = 'light';
        }
    }

    async onSpeichern(e: Event) {
        ClickHelper.click(e, () => this.doSpeichern());
    }

    async doSpeichern() {
        MyApp.loading(true);

        try {
            if (this.unterschriftComponent.istSignaturVorhanden()) {
                if (this.auftrag.UnterschriftText && !this.unterschriftTextBestaetigt) {
                    MyApp.loading(false);

                    const ok = await UiHelper.confirmJaNein(this.auftrag.UnterschriftText, 'Bitte bestätigen');

                    if (ok) {
                        this.unterschriftTextBestaetigt = true;
                        this.cdr.detectChanges();

                        MyApp.loading(true);

                        // Kurze Verzögerung, damit die Checkbox-Änderung sichtbar wird
                        await Utils.delay(500);

                    } else {
                        return;
                    }
                }

                const imageDataUrl = this.unterschriftComponent.getImageDataUrl();
                const imageData = await ImageHelper.dataUrlToImageData(imageDataUrl);
                const croppedCanvas = ImageHelper.cropImage(imageData);

                this.unterschrift.Bild = croppedCanvas.toDataURL();
                this.unterschrift.Data = this.unterschriftComponent.getSignaturData();
                this.unterschrift.Guid = Utils.uuid();
                this.unterschrift.Datum = Utils.nowIsoDateString();
                this.unterschrift.Position = await this.systemService.getAktuelleGpsPosition('unterschrift', 60);
            } else {
                this.unterschrift.Bild = null;
                this.unterschrift.Data = null;
                this.unterschrift.Guid = null;
                this.unterschrift.Datum = null;
                this.unterschrift.Position = null;
            }
        } catch (err) {
            this.log.error('doSpeichern', err);
        }

        await this.auftragService.speichereAuftrag(this.auftrag);

        MyApp.loading(false);

        this.modalController.dismiss(true);

        // await this.router.navigateByUrl('/auftragsliste/details/' + this.auftrag.Key);
    }

    onReset(e: Event) {
        ClickHelper.click(e, () => {
            this.unterschriftComponent.reset();
        });
    }
}
